import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-indicator-component',
  templateUrl: './progressIndicator.component.html',
  styleUrls: ['./progressIndicator.component.scss'],
})
export class ProgressIndicatorComponent {
  @Input() done: number;
  @Input() toDo: number;
}



// WEBPACK FOOTER //
// ./src/app/common/components/ProgressIndicatorComponent/progressIndicator.component.ts